// extracted by mini-css-extract-plugin
export var disabled = "_5s-3";
export var growableInput = "_5s-0";
export var tagContainer = "_5s-2";
export var textInput = "_5s-1";